import React, { useState, useEffect, useCallback } from "react";
import TestLeftSidebar from "./Sidebars/LeftSidebar";
import TestRightSidebar from "./Sidebars/RightSidebar";
import AssessmentTestRow from "./AssessmentTestRow";
import { getAllAssessmentSlots } from "../../api/candidates.api";
import useApiToken from "../../hooks/useApiToken";

interface AssessmentItem {
  id: string;
  assessmentName: string;
  roleName: string;
  roleStatus: string;
  dateTime: string;
  endTime: string | null;
  computedStatus: string;
}

const Tests: React.FC = () => {
  const token = useApiToken();
  const [isLeftOpen, setIsLeftOpen] = useState<boolean>(true);
  const [tests, setTests] = useState<AssessmentItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const [filterQuery, setFilterQuery] = useState<string>("");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [dateFilter, setDateFilter] = useState<string>("");



  // Fetch assessment slots from backend with filters
  const fetchAssessmentSlots = useCallback(async () => {
    if (!token) return;
    try {
      setLoading(true);
      const slots = await getAllAssessmentSlots(filterQuery, searchQuery, dateFilter, token);
      setTests(slots);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching assessment slots:", error);
      setLoading(false);
    }
  }, [filterQuery, searchQuery, dateFilter, token]);

  useEffect(() => {
    fetchAssessmentSlots();
  }, [fetchAssessmentSlots]);



  const handleFilterQuery = (query: string) => {
    setFilterQuery(query);
  };

  const handleSearchQuery = (query: string) => {
    setSearchQuery(query);
  };

  const handleDateFilter = (filter: string) => {
    setDateFilter(filter);
  };

  return (
    <div className="relative min-h-screen bg-gray-50 dark:bg-darkbg text-gray-900 dark:text-gray-100">
      <TestLeftSidebar
        onToggle={setIsLeftOpen}
        handleFilterQuery={handleFilterQuery}
        handleSearchQuery={handleSearchQuery}
        handleDateFilter={handleDateFilter}
      />
      <TestRightSidebar />

      <main
        className={`w-full mx-4 pt-2 pb-4 px-4 transition-[padding] duration-200 ease-in-out ${
          isLeftOpen ? "lg:pl-[19rem]" : "lg:pl-6"
        }`}
      >
        <div className="bg-white dark:bg-darkbglight rounded-md shadow-md border border-gray-200 dark:border-gray-700 p-4">
          <h2 className="text-lg font-semibold mb-3">Scheduled Tests</h2>
          <hr />
          {loading ? (
            <p className="text-sm text-gray-500 dark:text-gray-400">Loading...</p>
          ) : tests.length === 0 ? (
            <p className="text-sm text-gray-500 dark:text-gray-400">
              No assessments found for the current filters.
            </p>
          ) : (
            <ul className="space-y-3">
              {tests.map((item) => (
                <AssessmentTestRow
                  key={item.id}
                  assessment={item}
                />
              ))}
            </ul>
          )}
        </div>
      </main>
    </div>
  );
};

export default Tests;
